import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useIsProjectTopicManagementStepCompleted from 'ProjectManager/DataManagement/Navigation/hooks/useIsTopicManagementStepCompleted/useIsProjectTopicManagementStepCompleted';
import useIsTemplateTopicManagementStepCompleted from 'ProjectManager/DataManagement/Navigation/hooks/useIsTopicManagementStepCompleted/useIsTemplateTopicManagementStepCompleted';

const useIsTopicManagementStepCompleted = () => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const projectData = useIsProjectTopicManagementStepCompleted();
    const templateData = useIsTemplateTopicManagementStepCompleted();

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return projectData;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return templateData;
    }

    return false;
};

export default useIsTopicManagementStepCompleted;
